<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
</div>
<div class="modal-body card">
    <p>{{ message | translate }}</p>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="closeModal(false)">{{ 'GENERAL.CANCEL' | translate}}</button>
        <button type="button" class="btn btn-primary" (click)="closeModal(true);">{{ 'GENERAL.OK' | translate}}</button>
      </div>
</div>